import { IStepOption, TourService } from 'ngx-ui-tour-md-menu';
import { Subscription } from 'rxjs';

import { FeatureTourStep } from './tour.types';

export interface FeatureTourInitHandlers {
  onStepShow: (step?: IStepOption) => void;
  onTourEnd?: () => void;
}

export interface FeatureTourInitResult {
  stepSubscription: Subscription;
  endSubscription: Subscription;
}

// Backward compatibility aliases.
export type EmployeesTourInitHandlers = FeatureTourInitHandlers;
export type EmployeesTourInitResult = FeatureTourInitResult;

export const FEATURE_TOUR_DEFAULTS: Partial<FeatureTourStep> = {
  prevBtnTitle: 'Back',
  nextBtnTitle: 'Next',
  endBtnTitle: 'Finish',
  showProgress: true,
  enableBackdrop: true,
  backdropConfig: {
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    offset: 8,
  },
  stepDimensions: {
    maxWidth: '640px',
  },
};

export function initializeFeatureTour(
  tourService: TourService<FeatureTourStep>,
  steps: FeatureTourStep[],
  handlers: FeatureTourInitHandlers,
): FeatureTourInitResult {
  tourService.initialize(steps, FEATURE_TOUR_DEFAULTS);

  const stepSubscription = tourService.stepShow$
    .subscribe(({ step }) => handlers.onStepShow(step));

  const endSubscription = tourService.end$
    .subscribe(() => handlers.onTourEnd?.());

  return { stepSubscription, endSubscription };
}

// Backward compatibility exports for existing imports.
export const EMPLOYEES_TOUR_DEFAULTS = FEATURE_TOUR_DEFAULTS;
export const initializeEmployeesListTour = initializeFeatureTour;
